import React from 'react' 
import ReactMarkdown from 'react-markdown'
import classnames from 'classnames'
import {
  getPositionStyle } from '../../lib/gridUtil'
import './bio-module.css'

const renderList = list => (
  <ul className="bio__list">
  {list.map((item, index) => (
    <li key={index} className="bio__listitem">
      <div className="bio__listitem-title text--small-serif">{item.title}</div>
      <div className="bio__listitem-body text--small-serif">{item.body}</div>
    </li>
  ))}
  </ul>
)

const BioModule = ({ 
  vw,
  layout,
  body,
  title,
  list,
  colSpan,
  xOffset,
  yOffset }) => {

  const layoutClassName = `bio__${layout}`

  const moduleClassNames = classnames({
    [layoutClassName]: true
  }, 'bio__module')

  return (
    <div className={moduleClassNames}>
      <div className="bio__module-inner--mobile">
        <div className="bio__title text--small">{title}</div>
        <div className="bio__body text--small-serif">
          {body && <ReactMarkdown source={body} />}
        </div>
        {list && renderList(list)}
      </div>
      <div 
        style={getPositionStyle(vw, xOffset, yOffset, colSpan)} 
        className="bio__module-inner">
        <div className="bio__title text--small">{title}</div>
        <div className="bio__body text--small-serif">
          {body && <ReactMarkdown source={body} />}
        </div>
        {list && renderList(list)}
      </div>
    </div>
  )
}

export default BioModule


// WEBPACK FOOTER //
// ./src/components/artist-bio-module/index.js